<script>
const FLAGS = [
  'meta_noindex',
  'meta_nofollow',
  'meta_noarchive',
  'meta_nosnippet',
  'meta_notranslate',
  'meta_noimageindex'
]

const I18N_KEY = {
  meta_noindex: 'noindex',
  meta_nofollow: 'nofollow',
  meta_noarchive: 'noarchive',
  meta_nosnippet: 'nosnippet',
  meta_notranslate: 'notranslate',
  meta_noimageindex: 'noimageindex'
}

export default {
  name: 'MetaRobots',
  components: {
    Checkbox: () => import('@/components/general/Checkbox')
  },

  props: {
    values: {
      type: Object,
      required: true
    }
  },

  computed: {
    flags () {
      return FLAGS.map((key) => {
        const suffix = I18N_KEY[key]

        return {
          key,
          checked: Boolean(this.values[key]),
          items: [
            {
              value: key,
              label: this.$t(`articles.form:metarobots.${suffix}`),
              description: this.$t(`articles.form:metarobots.${suffix}.desc`)
            }
          ]
        }
      })
    }
  },

  methods: {
    onToggle (key, value) {
      this.$emit('input', { [key]: Boolean(value) })
    }
  }
}
</script>

<template>
  <div class="article-metarobots-list">
    <Checkbox
      v-for="flag in flags"
      :key="flag.key"
      :value="flag.checked"
      :items="flag.items"
      switch-type
      @input="(value) => onToggle(flag.key, value)"
    />
  </div>
</template>
